import { render, staticRenderFns } from "./sendTestMedia.vue?vue&type=template&id=595cd98c&scoped=true"
import script from "./sendTestMedia.vue?vue&type=script&lang=js"
export * from "./sendTestMedia.vue?vue&type=script&lang=js"
import style0 from "./sendTestMedia.vue?vue&type=style&index=0&id=595cd98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595cd98c",
  null
  
)

export default component.exports